import { Log } from "interfaces/Log";
import React from "react";
import { dateFormatter, FORMATTER_OPTIONS } from "utils/dates";

type Props = {
  data: Log[];
};

export const LogsContainer = ({ data }: Props) => {
  return data.length > 0 ? (
    <div className="flex flex-col gap-2 py-2 pl-4 overflow-y-auto rounded-md shadow bg-gradient-to-b from-faux-black-coral to-faux-onyx max-h-96">
      {React.Children.toArray(
        data.map((log: any) => (
          <div className="flex flex-row items-center py-1">
            <p className=" min-w-140">
              {`${dateFormatter(log.dateTime, FORMATTER_OPTIONS.log_sec)} | ${log.description}`}
            </p>
          </div>
        )),
      )}
    </div>
  ) : (
    <div className="flex flex-col gap-2 px-4 py-2 overflow-y-auto rounded-md shadow bg-gradient-to-b from-faux-black-coral to-faux-onyx max-h-48">
      <p className="text-white">No se encontraron registros</p>
    </div>
  );
};
